
const SETDAYNUM='SETDAYNUM'
const SETAVATAR='SETAVATAR'

export default {
  [SETDAYNUM](state,str){
    state.dayNum=str
  },
  [SETAVATAR](state,str){
    state.avatar=str
  },

}



// WEBPACK FOOTER //
// ./src/store/mutations.js